"use client";

import React, { ReactNode, CSSProperties } from "react";

interface ScrollContainerProps {
  height?: string | number; 
  width?: string | number;  
  children: ReactNode;
  className?: string;
  direction?: "vertical" | "horizontal";
}

export function ScrollContainer({
  height,
  width,
  children,
  className = "",
  direction = "vertical",
}: ScrollContainerProps) {
  const style: CSSProperties = {
    ...(height !== undefined ? { height } : {}),
    ...(width !== undefined ? { width } : {}),
    overflowY: direction === "vertical" ? "auto" : "hidden",
    overflowX: direction === "horizontal" ? "auto" : "hidden",
  };

  return (
    <div style={style} className={className}>
      {children}
    </div>
  );
}
